import { ApiProperty, IsNotEmpty, IsString, IsDefined, Type, ValidateNested, IsEnum } from './decorators-nest';

class ShopifyCustomerDto {
  /**
   * ID of the Shopify customer
   * @example "gid://shopify/Customer/5722087948390"
   */
  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  id: string;

  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  email: string;

  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  firstName: string;

  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  lastName: string;
}
export class AdressDto {
  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  address1: string;

  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  zip: string;

  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  city: string;

  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  country: string;

  @IsString()
  @ApiProperty()
  phone: string;
}

export class ShopifyDeliveryMethodDto {
  @Type(() => AdressDto)
  @ValidateNested()
  @ApiProperty()
  address: AdressDto;
}

export class ShopifyLinesDto {
  /**
   * @example "[{'__typename': 'SubscriptionLineEdge', 'node': {'__typename': 'SubscriptionLine', 'id': 'gid://shopify/SubscriptionLine/95e6a395-5bbc-461a-9f13-9c38f01cc42c', 'sellingPlanId': 'gid://shopify/SellingPlan/539656294', 'sellingPlanName': 'Monthly', 'productId': 'gid://shopify/Product/6754578858086', 'sku': 'BMM', 'title': 'BeMum', 'variantId': 'gid://shopify/ProductVariant/39724758270054', 'quantity': 1, 'customAttributes': [{'__typename': 'Attribute', 'key': 'Email', 'value': 'picaud.marc@gmail.com'}], 'lineDiscountedPrice': {'__typename': 'MoneyV2', 'amount': '0.0', 'currencyCode': 'USD'}, 'variantImage': {'__typename': 'Image', 'transformedSrc': 'https://cdn.shopify.com/s/files/1/0549/1585/8534/products/273016663_3116239005278311_4002152295636554201_n_1.jpg?v=1661883532'}, 'variantTitle': '-', 'currentPrice': {'__typename': 'MoneyV2', 'amount': '150.0', 'currencyCode': 'USD'}, 'discountAllocations': [{'__typename': 'SubscriptionDiscountAllocation', 'amount': {'__typename': 'MoneyV2', 'amount': '150.0', 'currencyCode': 'USD'}, 'discount': {'__typename': 'SubscriptionManualDiscount', 'id': 'gid://shopify/SubscriptionManualDiscount/f41c0d97-3e4e-4452-8f21-1120e9f09599'}}], 'pricingPolicy': None, 'taxable': False}}]"
   */
  @IsString()
  edges: string;
}

/**
 * Used in webhook handlers to know wether the subscription is SilWeight
 */
export enum ShopifyBemumProducts {
  /** @see https://bemum2.myshopify.com/admin/products/7262851924141*/
  BEMUM = 'gid://shopify/SellingPlan/952631469',
}

/**
 * Used in webhook handlers to know subscription options
 */
export enum ShopifyBeMumProductsVariants {
  /** @see https://bemum2.myshopify.com/admin/products/*/
  ESSENTIEL_SUPPLEMENTS = '41991131234477',
  ESSENTIEL_COACHING = '41991129989293',
  ANTIOX = '41991132414125',
  EQUILIBRE = '41991131889837',
  COACHING_PLUS = '41991130808493',
}

export enum ShopifySubscriptionStatus {
  PAUSED = 'PAUSED',
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
}

/**
 * Webhook payload for a subscription even
 * @example {"":{"typename":"SubscriptionContract"},"billingPolicy":{"":{"typename":"SubscriptionBillingPolicy"},"anchors":"[]","interval":"MONTH","intervalCount":"1","maxCycles":"","minCycles":""},"createdAt":"2022-09-01T18:17:16Z","customerPaymentMethod":{"":{"typename":"CustomerPaymentMethod"},"id":"gid://shopify/CustomerPaymentMethod/4f641f184dafed8d3566688a5c1cc462","instrument":{"":{"typename":"CustomerShopPayAgreement"},"expiresSoon":"False","expiryMonth":"6","expiryYear":"2027","lastDigits":"7752","maskedNumber":"•••• •••• •••• 7752","name":"Marc Picaud","revocable":"False"}},"customer":{"":{"typename":"Customer"},"displayName":"Marc Picaud","email":"picaud.marc@gmail.com","firstName":"Marc","id":"gid://shopify/Customer/5722087948390","lastName":"Picaud"},"deliveryMethod":{"":{"typename":"SubscriptionDeliveryMethodShipping"},"address":{"":{"typename":"SubscriptionMailingAddress"},"address1":"10 rue de penthievre","address2":"","city":"paris","company":"","country":"United States","countryCode":"US","firstName":"Marc","lastName":"Picaud","name":"Marc Picaud","phone":"","province":"Alaska","provinceCode":"AK","zip":"99950"},"shippingOption":{"":{"typename":"SubscriptionDeliveryMethodShippingOption"},"code":"Standard International","description":"","presentmentTitle":"Standard International","title":"Standard International"}},"deliveryPolicy":{"":{"typename":"SubscriptionDeliveryPolicy"},"anchors":"[]","interval":"MONTH","intervalCount":"1"},"deliveryPrice":{"":{"typename":"MoneyV2"},"amount":"0.0","currencyCode":"USD"},"discounts":{"":{"typename":"SubscriptionManualDiscountConnection"},"edges":"[{'__typename': 'SubscriptionManualDiscountEdge', 'node': {'__typename': 'SubscriptionManualDiscount', 'id': 'gid://shopify/SubscriptionManualDiscount/782c2c78-e937-496f-b361-7bd7332a38ab', 'title': 'FREE', 'value': {'__typename': 'SubscriptionDiscountPercentageValue', 'percentage': 100}, 'recurringCycleLimit': None}}]"},"id":"gid://shopify/SubscriptionContract/2416509030","lastPaymentStatus":"","lines":{"":{"typename":"SubscriptionLineConnection"},"edges":"[{'__typename': 'SubscriptionLineEdge', 'node': {'__typename': 'SubscriptionLine', 'id': 'gid://shopify/SubscriptionLine/6dd27f94-e72d-4406-89e0-312f84c7726a', 'sellingPlanId': 'gid://shopify/SellingPlan/539623526', 'sellingPlanName': 'Monthly', 'productId': 'gid://shopify/Product/6754578595942', 'sku': 'BDY', 'title': 'BeDaddy', 'variantId': 'gid://shopify/ProductVariant/39724757418086', 'quantity': 1, 'customAttributes': [{'__typename': 'Attribute', 'key': 'Email', 'value': 'picaud.marc@gmail.com'}], 'lineDiscountedPrice': {'__typename': 'MoneyV2', 'amount': '0.0', 'currencyCode': 'USD'}, 'variantImage': {'__typename': 'Image', 'transformedSrc': 'https://cdn.shopify.com/s/files/1/0549/1585/8534/products/272056487_485577776336107_8253334217207296621_n.jpg?v=1661884417'}, 'variantTitle': '-', 'currentPrice': {'__typename': 'MoneyV2', 'amount': '150.0', 'currencyCode': 'USD'}, 'discountAllocations': [{'__typename': 'SubscriptionDiscountAllocation', 'amount': {'__typename': 'MoneyV2', 'amount': '150.0', 'currencyCode': 'USD'}, 'discount': {'__typename': 'SubscriptionManualDiscount', 'id': 'gid://shopify/SubscriptionManualDiscount/782c2c78-e937-496f-b361-7bd7332a38ab'}}], 'pricingPolicy': None, 'taxable': True}}]"},"nextBillingDate":"2022-10-01T18:00:00Z","note":"","originOrder":{"":{"typename":"Order"},"fulfillmentOrders":{"":{"typename":"FulfillmentOrderConnection"},"edges":"[{'__typename': 'FulfillmentOrderEdge', 'node': {'__typename': 'FulfillmentOrder', 'fulfillAt': '2022-09-01T18:00:00Z', 'id': 'gid://shopify/FulfillmentOrder/5623487168614', 'status': 'OPEN'}}]"},"id":"gid://shopify/Order/4582895616102","name":"#1006"},"status":"ACTIVE"}
 */
export class ShopifySubscriptionContractDto {
  /**
   * ID of the Appstle subscription
   * @example "gid://shopify/SubscriptionContract/2416509030"
   */
  @IsString()
  @IsNotEmpty()
  @ApiProperty()
  id: string;

  @IsString()
  @ApiProperty()
  createdAt: Date;

  @IsString()
  @ApiProperty()
  nextBillingDate: Date;

  @IsEnum(ShopifySubscriptionStatus)
  @ApiProperty()
  status: ShopifySubscriptionStatus;

  @Type(() => ShopifyCustomerDto)
  @ValidateNested()
  @ApiProperty()
  customer: ShopifyCustomerDto;

  @Type(() => ShopifyLinesDto)
  @ValidateNested()
  @ApiProperty()
  lines: ShopifyLinesDto;

  @Type(() => ShopifyDeliveryMethodDto)
  @ValidateNested()
  @ApiProperty()
  deliveryMethod: ShopifyDeliveryMethodDto;
}

export class CreateShopifyCheckoutSessionDto {
  @IsNotEmpty()
  @IsString()
  @ApiProperty()
  domainURL: string;

  @IsNotEmpty()
  @IsDefined()
  @ApiProperty()
  withShipping: boolean;

  @IsNotEmpty()
  @IsDefined()
  @ApiProperty()
  withEssentielSupplements: boolean;

  @IsNotEmpty()
  @IsDefined()
  @ApiProperty()
  withEssentielCoaching: boolean;

  @IsNotEmpty()
  @IsDefined()
  @ApiProperty()
  withCoachingOption: boolean;

  @IsNotEmpty()
  @IsDefined()
  @ApiProperty()
  withStructurantOption: boolean;

  @IsNotEmpty()
  @IsDefined()
  @ApiProperty()
  withProtecteurOption: boolean;
}
/** Stripe Customer Portal Session */
export interface ShopifySession {
  manageSubscriptionLink: string;
}
